import { createSelector } from "reselect";
import { getSavingsPotCalculatorState } from './index';

export const getScrolling = createSelector(
    getSavingsPotCalculatorState,
    savingsPotCalculator =>  savingsPotCalculator.scrolling
);

export const getScrollToClass = createSelector(
    getScrolling,
    scrolling => scrolling.scrollToClass,
)

export const getScrollToId = createSelector(
    getScrolling,
    scrolling => scrolling.scrollToId,
)